import React from 'react';
import { StoryCard } from '../StoryCard';

class TriviaCard extends StoryCard<any> {
	render() {
		return <div className="trivia-card">{super.renderCard()}</div>;
	}
}

export default TriviaCard;
